import { STORAGE_KEY } from '../const';

const CACHE_DURATION = 5 * 60 * 1000;

const cache = {};

function get(key) {
  const cacheDetails = cache[key];
  if (!cacheDetails) {
    return;
  }

  if (cacheDetails.expiry > Date.now()) {
    return cacheDetails.data;
  }
}

function store(key, data) {
  cache[key] = { data, expiry: Date.now() + CACHE_DURATION };
}

function saveOrderToLocalStorage(order, shopId) {
  const orders = JSON.parse(localStorage.getItem(`${shopId}-${STORAGE_KEY.ORDERS}`) || '[]');
  const updatedOrders = orders.filter(({ id }) => id !== order.id).concat(order);
  localStorage.setItem(`${shopId}-${STORAGE_KEY.ORDERS}`, JSON.stringify(updatedOrders));
}

function getCustomerFromLocalStorage(shopId) {
  const customerData = JSON.parse(localStorage.getItem(`${shopId}-${STORAGE_KEY.CUSTOMER_DETAILS}`) || '{}');
  return customerData
}

function setCustomerToLocalStorage(shopId, customer) {
  localStorage.setItem(`${shopId}-${STORAGE_KEY.CUSTOMER_DETAILS}`, JSON.stringify(customer));
}

const CacheHelper = {
  get,
  store,
  saveOrderToLocalStorage,
  getCustomerFromLocalStorage,
  setCustomerToLocalStorage,
};

export default CacheHelper;
